import { render, staticRenderFns } from "./AdditionalCosts.vue?vue&type=template&id=27bc65a4&"
import script from "./AdditionalCosts.vue?vue&type=script&lang=js&"
export * from "./AdditionalCosts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports